import * as React from "react"
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md"
import { css } from "@emotion/react"
import { device } from "../styles/device"

export function NumericInput({ onIncrement, onDecrement, className, disabled, ...props }) {
    return (
        <div css={numInput}>
            <input disabled={disabled} type="numeric" {...props} css={inputText} />
            <button disabled={disabled} aria-label="Increment" onClick={onIncrement} css={[button, increment]}>
                <MdArrowDropUp />
            </button>
            <button disabled={disabled} aria-label="Decrement" onClick={onDecrement} css={[button, decrement]}>
                <MdArrowDropDown />
            </button>
        </div>
    )
}
const numInput = css`
    display: inline-grid;
    grid-template-columns: 1fr min-content;
    grid-template-areas:
        "input increment"
        "input decrement";
    width: 100%;

    @media ${device.tb} {
        height: 50px;
        grid-template-columns: 1fr 20% 20%;
        grid-template-areas: "input decrement increment";
    }
`
const inputText = css`
    grid-area: input;
    align-self: stretch;
    border: solid 1px black;
    border-right: none;
    padding: 4px 0 4px 16px;
    background: white;
    font-size: 1.4rem;
    width: 100%;

    @media ${device.tb} {
        text-align: center;
        padding: 0;
        font-size: 1.6rem;
    }
`
const button = css`
    border: solid 1px black;
    display: grid;
    place-items: center;
    background: white;
    cursor: pointer;
    svg {
        width: 20px;
        height: 20px;
    }

    &:hover {
        background: black;
        svg {
            fill: white;
        }
    }

    @media ${device.tb} {
        svg {
            width: 30px;
            height: 30px;
        }
    }
`
const increment = css`
    grid-area: increment;
`
const decrement = css`
    grid-area: decrement;
    border-top: none;
    @media ${device.tb} {
        border-top: solid 1px black;
        border-right: none;
    }
`
